import { render, staticRenderFns } from "./order-status-mobile.vue?vue&type=template&id=b76504e0&scoped=true"
import script from "./order-status-mobile.vue?vue&type=script&lang=js"
export * from "./order-status-mobile.vue?vue&type=script&lang=js"
import style0 from "./order-status-mobile.vue?vue&type=style&index=0&id=b76504e0&prod&lang=css"
import style1 from "./order-status-mobile.vue?vue&type=style&index=1&id=b76504e0&prod&scoped=true&lang=css"
import style2 from "./order-status-mobile.vue?vue&type=style&index=2&id=b76504e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76504e0",
  null
  
)

export default component.exports